import { Controller } from "@hotwired/stimulus"

// On a slot's field group. A click on a chip in the row under the editor
// inserts that variable at the cursor (at the end when the editor has none),
// through the same attachment markup the {{ prompt inserts. The button keeps
// the focus where it is, so the cursor stays put and no blur fires a preview.
// The ghost is the rendered default, laid over the editor's content area while
// the editor is empty (Lexxy's lexxy-editor--empty class shows and hides it).
export default class extends Controller {
  static targets = ["editor", "ghost"]

  connect() {
    this.observer = new ResizeObserver(() => this.place())
    this.place()
  }

  disconnect() {
    this.observer.disconnect()
  }

  keepFocus(event) {
    event.preventDefault()
  }

  insert({ params: { html } }) {
    this.editorTarget.contents.insertHtml(html)
    this.editorTarget.focus()
  }

  place() {
    const field = this.editorTarget.querySelector("[contenteditable=true]")
    if (!field || !this.hasGhostTarget) return

    this.observer.observe(field)
    const box = field.getBoundingClientRect()
    const origin = this.ghostTarget.offsetParent?.getBoundingClientRect() ?? box
    const style = getComputedStyle(field)
    Object.assign(this.ghostTarget.style, {
      top: `${box.top - origin.top}px`,
      left: `${box.left - origin.left}px`,
      width: `${box.width}px`,
      height: `${box.height}px`,
      padding: style.padding
    })
  }
}
